import { render, staticRenderFns } from "./formDataBank.vue?vue&type=template&id=3e72dd42&scoped=true"
import script from "./formDataBank.vue?vue&type=script&lang=js"
export * from "./formDataBank.vue?vue&type=script&lang=js"
import style0 from "./formDataBank.vue?vue&type=style&index=0&id=3e72dd42&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72dd42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e72dd42')) {
      api.createRecord('3e72dd42', component.options)
    } else {
      api.reload('3e72dd42', component.options)
    }
    module.hot.accept("./formDataBank.vue?vue&type=template&id=3e72dd42&scoped=true", function () {
      api.rerender('3e72dd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/bank/components/form/step/formDataBank.vue"
export default component.exports